<template>
  <div id="technology" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>技術分野</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="technology" />

        <div class="page-card">
          <p class="page-kicker">Technology</p>
          <h2>対応技術領域</h2>
          <table class="table">
            <tbody>
              <tr>
                <th class="w-25" scope="row">OS</th>
                <td>WINDOWS、iOS、Android、UNIX、LINUX、DOS、リアルタイムOS(ITRON、ARM7)、汎用機(ACOS)</td>
              </tr>
              <tr>
                <th scope="row">データベース</th>
                <td>Oracle、SQLServe、DB2、MySql、PostgreSQL、Ms-Access</td>
              </tr>
              <tr>
                <th scope="row">開発言語</th>
                <td>Java (JSP、EJB、J2ME等)、.NET(ASP.NET、VB.NET、C#.NET等)、Unity、C、C++、VisualC++、VisualBasic、Cobol、JavaScript、VBScript、ASP、Perl、PHP、Python、XML、UML、PL/SQL</td>
              </tr>
              <tr>
                <th scope="row">プロトコル</th>
                <td>HTTP、TCP/IP、IPX、NetBEU</td>
              </tr>
              <tr>
                <th scope="row">APサーバ</th>
                <td>Tomcat、Weblogic、Webshpere、InterStage、JRun、JServer</td>
              </tr>
            </tbody>
          </table>

          <div class="info-panel">
            <h3>ご提案</h3>
            <p>お客様のご希望に応じシステム開発の多様なフェーズに対応し、必要な期間、必要なIT人材をご提案致します。</p>
          </div>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'technology',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
